const hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
};

export const getRgbaColor = (color, opacity) => {
  return hexToRGB(color, opacity);
};

/**
 * Lighten or darken the color
 * @param hexColor Color in hexadecimal format
 * @param amount Percentage to lighten or darken
 */
export function adjustColorBrightness(hexColor, amount) {
  return `#${hexColor
    .replace(/^#/, "")
    .replace(/../g, (color) =>
      `0${Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(
        16
      )}`.substr(-2)
    )}`;
}
